import { render } from "./maixFooter.vue?vue&type=template&id=05cb7f80&scoped=true"
import script from "./maixFooter.vue?vue&type=script&lang=js"
export * from "./maixFooter.vue?vue&type=script&lang=js"

import "./maixFooter.vue?vue&type=style&index=0&id=05cb7f80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05cb7f80"]])

export default __exports__